












































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
import moment from "moment";
import VueScrollTo from "vue-scrollto";
import _get from "lodash/get";
import CustomerUser from "@/model/customerUser";
import QCalendar from "@/common/qCalendar.vue";
import OrderComplete from "@/components/cutomer/orderComplete.vue";
import commonApi, { FSystem } from "@/api/commonApi";
import Product, { SaleBoom } from "@/model/product";
import { CartItemList } from "@/model/cart";
import productApi from "@/api/productApi";
import qNotify from "@/common/qNotify";
import QErrors from "@/common/qErrors.vue";
import DeliveryDestinationList from "@/components/cutomer/deliveryDestination/deliveryDestinationList.vue";
import orderApi from "@/api/orderApi";
import qInput from "@/components/common/qInput.vue";
import qTextArea from "@/components/common/qTextArea.vue";
import ProductListPopup from "@/components/cutomer/productListPopup.vue";

import {
  HTTP_STATUS_CREATED,
  HTTP_STATUS_NO_CONTENT,
  HTTP_STATUS_OK,
  HTTP_STATUS_VALIDATE_FAILURE,
  ITEM_STATUS_DELETED,
} from "@/common/constant";
import RemoveItemInactive from "@/mixin/removeItemInactive";
const cartStore = namespace("Cart");
const authStore = namespace("Auth");
const orderStore = namespace("OrderInformation");

// eslint-disable-next-line @typescript-eslint/no-var-requires
const noimage = require("@/assets/images/muuq-base/noimage.png");
// eslint-disable-next-line @typescript-eslint/no-var-requires
const defaultImage0082 = require("@/assets/images/common/000082.png");
// eslint-disable-next-line @typescript-eslint/no-var-requires
const defaultImage0083 = require("@/assets/images/common/000083.png");

@Component({
  name: "Order",
  components: {
    QCalendar,
    DeliveryDestinationList,
    QErrors,
    OrderComplete,
    qInput,
    qTextArea,
    ProductListPopup
  },
})
export default class Order extends Mixins(RemoveItemInactive) {
  @Prop({
    default: null,
  })
  orderId;

  @authStore.Getter
  getCustomerUser!: CustomerUser;

  @cartStore.Getter
  cartItems!: any[];
  @cartStore.Action
  cartRemove!: (index) => void;
  @cartStore.Action
  replaceCart!: (item) => void;
  @cartStore.Action
  addCart!: (item) => void;

  @orderStore.Getter
  orderItems!: any[];
  @orderStore.Getter
  getIsUpdateFlash!: boolean;
  @orderStore.Action
  orderInformationRemove!: () => void;
  @orderStore.Action
  replaceOrderInformation!: (item) => void;
  @orderStore.Action
  isUpdateFlash!: (boolean) => void;

  public items: CartItemList = new CartItemList();
  public shippingFeePrice = 0;
  public shippingPipeFeePrice = 0;
  public consumptionTax = 10;
  public edit = true;
  public deliveryConfigMaxTimeExceeded = null;
  public fSystemSetting: FSystem = {
    limitOverExceed: 5,
  };
  public errors: any = {};
  public isComplete = false;
  public isShowAttent = false;
  public cartsOfOrder = [];
  public form = {
    usingInfoAsDelivery: false,
    customer_supervisor_name: "",
    delivery: {
      ship_lbl_note: "",
      dlv_dst_supervisor_name: "",
      prefectures_code: "",
    },
    order_num: "",
    mnfct_num: "",
    desire_dlvr_day: "",
    deliver_time_am: 0,
  };
  public deliveryDestination = {
    dlv_dst_name: "",
    postal_code: "",
    address_1: "",
    address_2: "",
    tel_number: "",
    prefectures_code: "",
    prefectures_name: "",
    supervisor_name: "",
    dlv_fmt_note: "",
    cart_dlv_dst_code: "",
  };
  public deliveryInfo = {
    dst_name: "",
    postal_code: "",
    address_1: "",
    address_2: "",
    tel_number: "",
    prefectures_code: "",
    cart_dlv_dst_code: "",
    prefecture_name: "",
  };

  public dateConfig = {
    disableMobile: "true",
  };
  public deliveryConfig = {
    order_deadline_hour: 10,
    order_deadline_minute: 10,
    calendar_period: 90,
    free_shipping: 3000,
  };
  public relayFree = 0;
  public taxRate = 0;

  public postageItem = {
    order_num: '',
    mnfct_num: '',
    quantity: 1,
    unit: '',
    item_name: '',
    item_code: '000082',
  };
  public pipPostageItem = {
    order_num: '',
    mnfct_num: '',
    quantity: 1,
    unit: '',
    item_name: '',
    item_code: '000083',
  };

  public unDisplayItemCodes = ['000082', '000083', '000085'];

  @Watch('shippingFee')
  clearPostageItem() {
    if (this.shippingFee == 0) {
      this.postageItem.order_num = '';
      this.postageItem.mnfct_num = '';
    }
  }

  @Watch('shippingPipeFee')
  clearPipPostageItem() {
    if (this.shippingPipeFee == 0) {
      this.pipPostageItem.order_num = '';
      this.pipPostageItem.mnfct_num = '';
    }
  }


  async mounted() {
    this.items = new CartItemList();
    this.form.customer_supervisor_name =
      this.getCustomerUser.account_supervisor_name;
    if (this.orderId) {
      await this.loadOrder();
    }
    this.loadData();
    await Promise.all([
      this.loadPostageItem(),
      this.loadFSystemSetting(),
      this.loadDeliverySetting({
        notLoading: true,
      }),
      this.getTaxRate(),
      this.shippingFeeByPref(),
    ]);
    // await this.loadFSystemSetting();
    // await this.loadDeliverySetting({
    //   notLoading: true,
    // });
    // this.shippingFeeByPref();
    this.generateDate();
    // this.getTaxRate();
  }

  get customer() {
    return this.getCustomerUser.m_cart_customer;
  }

  get getItems() {
    if (this.orderId) {
      return this.cartsOfOrder;
    } else {
      return this.cartItems;
    }
  }

  get showFreeShip() {
    return this.items.total < this.deliveryConfig.free_shipping;
  }

  async loadOrder() {
    const result = await orderApi.getHistoryParentRecord({
      denno_orre: this.orderId,
      status: ["受付済"],
      date_type: 2,
    });

    if (result.orderHistories.length > 0) {
      let parentRows: any = result.orderHistories.shift();
      let childRows = parentRows.child_rows;

      let carts = [];
      let orderInformation = {};
      let desire_dlvr_day =
        childRows.length > 0 ? childRows[0].desire_dlvr_day : "";

      orderInformation = {
        delivery: {
          dst_name: parentRows.dlv_dst_name ?? "",
          postal_code: parentRows.dlv_dst_postal_code ?? "",
          prefectures_code: parentRows.prefectures_code ?? "",
          address_1: parentRows.dlv_dst_address_1 ?? "",
          address_2: parentRows.dlv_dst_address_2 ?? "",
          tel_number: parentRows.dlv_dst_tel_number ?? "",
        },
        desire_dlvr_day: desire_dlvr_day,
        dlv_dst_supervisor_name: parentRows.dlv_dst_supervisor_name ?? "",
        ship_lbl_note: parentRows.ship_lbl_note ?? "",
        mnfct_num: parentRows.mnfct_num,
        order_num: parentRows.order_num,
        customer_supervisor_name:
          parentRows.customer_supervisor_name ??
          this.getCustomerUser.account_supervisor_name,
        deliver_time_am: parentRows.deliver_time_am,
      };

      childRows
        .filter((item) => item.status != ITEM_STATUS_DELETED)
        .map((cart) => {
          if (cart.set_item_code) {
            carts.push({
              set_item_code: cart.set_item_code,
              item_code: cart.item_code,
              cart_quanlity: cart.set_quantity ?? 0,
              desire_dlvr_day: cart.desire_dlvr_day ?? "",
              mnfct_num: cart.mnfct_num,
              order_num: cart.order_num,
              customer_supervisor_name:
                cart.customer_supervisor_name ??
                this.getCustomerUser.account_supervisor_name,
              cart_orre_ctrl_num: cart.cart_orre_ctrl_num,
            });
          } else {
            carts.push({
              set_item_code: null,
              item_code: cart.item_code,
              cart_quanlity: cart.orre_quantity ?? 0,
              desire_dlvr_day: cart.desire_dlvr_day ?? "",
              mnfct_num: cart.mnfct_num,
              order_num: cart.order_num,
              customer_supervisor_name:
                cart.customer_supervisor_name ??
                this.getCustomerUser.account_supervisor_name,
              cart_orre_ctrl_num: cart.cart_orre_ctrl_num,
            });
          }

          if (cart.item_code == '000082') {
            this.postageItem.order_num = cart.order_num;
            this.postageItem.mnfct_num = cart.mnfct_num;
          } else if (cart.item_code == '000083') {
            this.pipPostageItem.order_num = cart.order_num;
            this.pipPostageItem.mnfct_num = cart.mnfct_num;
          }
        });
      // console.log(carts, orderInformation);
      this.cartsOfOrder = carts;
      this.fillInformationFromOrder(orderInformation);
      // set delivery info
      // set delivery date
      // set order number
    } else {
      this.$router.push({ name: "error" });
    }
  }

  fillInformationFromOrder(order) {
    this.form.customer_supervisor_name = order.customer_supervisor_name;
    this.form.delivery.dlv_dst_supervisor_name = order.dlv_dst_supervisor_name;
    this.form.delivery.ship_lbl_note = order.ship_lbl_note;
    this.form.desire_dlvr_day = order.desire_dlvr_day;
    this.deliveryInfo.dst_name = order.delivery.dst_name;
    this.deliveryInfo.postal_code = order.delivery.postal_code;
    this.deliveryInfo.address_1 = order.delivery.address_1;
    this.deliveryInfo.address_2 = order.delivery.address_2;
    this.deliveryInfo.tel_number = order.delivery.tel_number;
    this.deliveryInfo.prefectures_code = order.delivery.prefectures_code;

    this.form.mnfct_num = order.mnfct_num;
    this.form.order_num = order.order_num;
    this.form.deliver_time_am = order.deliver_time_am;
  }

  public async loadFSystemSetting() {
    const result = await commonApi.fSystem({
      notLoading: true,
    });
    this.fSystemSetting = result;
    this.deliveryConfigMaxTimeExceeded = moment().add(
      this.fSystemSetting.limitOverExceed || 5,
      "days"
    );
  }

  public async loadDeliverySetting(parameters = {}) {
    const result = await commonApi.setting(parameters);
    this.deliveryConfig = result;
  }

  public changeDelivery() {
    console.log("Choose delivery");
    this.clearError("dlv_dst_supervisor_name");
    this.clearError("ship_lbl_note");
    this.updateDeliveryByFromUsingInfo();
    this.shippingFeeByPref();
  }

  updateDeliveryByFromUsingInfo() {
    if (this.form.usingInfoAsDelivery) {
      this.form.delivery.dlv_dst_supervisor_name =
        this.form.customer_supervisor_name;
      this.deliveryInfo.dst_name = this.customer.customer_name;
      this.deliveryInfo.postal_code = this.customer.postal_code;
      this.deliveryInfo.address_1 = this.customer.address_1;
      this.deliveryInfo.address_2 = this.customer.address_2;
      this.deliveryInfo.tel_number = this.customer.tel_number;
      this.deliveryInfo.prefectures_code = this.customer.prefecture_code;
      this.deliveryInfo.prefecture_name = this.getPrefectureNameCurrentLogin;
    } else {
      this.form.delivery.dlv_dst_supervisor_name = "";
      this.form.delivery.ship_lbl_note = "";
      this.deliveryInfo.dst_name = "";
      this.deliveryInfo.postal_code = "";
      this.deliveryInfo.address_1 = "";
      this.deliveryInfo.address_2 = "";
      this.deliveryInfo.tel_number = "";
      this.deliveryInfo.prefectures_code = "";
      this.deliveryInfo.prefecture_name = "";
    }
  }

  public async generateDate() {
    const today = moment();
    const dueDate = moment().add(this.deliveryConfig.calendar_period, "day");
    const result = await commonApi.calendar({
      is_holiday: true,
      date_from: today.format("YYYYMMDD"),
      date_to: dueDate.format("YYYYMMDD"),
      notLoading: true,
    });

    const expiredTime = today.isAfter(
      moment()
        .set("hour", this.deliveryConfig.order_deadline_hour)
        .set("minute", this.deliveryConfig.order_deadline_minute)
    );
    let minDate = today.toDate();

    if (expiredTime) {
      minDate = moment().add(1, "day").toDate();
    }

    this.dateConfig = {
      ...this.dateConfig,
      ...{
        disable: result.map((item) => item.date_object),
        minDate: minDate,
        maxDate: dueDate.toDate(),
        disableMobile: "true",
      },
    };
  }

  public async getTaxRate() {
    const result = await commonApi.tax({});
    this.taxRate = result.tax_rate;
  }

  async loadData() {
    // const loader = Vue.$loading.show({});
    let setItemCode = this.getItems
      .filter((item) => item.set_item_code)
      .map((item) => item.set_item_code);
    let itemCode = this.getItems
      .filter((item) => !item.set_item_code)
      .map((item) => item.item_code);

    const request: any = [];
    if (setItemCode.length > 0) {
      request.push(
        productApi.getSaleBoms({
          set_item_code: setItemCode,
        })
      );
    } else {
      request.push([]);
    }

    if (itemCode.length > 0) {
      request.push(
        productApi.getAll({
          item_codes: itemCode,
          is_publish: true,
          per_page: 100000,
          include_sales_judge_kbn: true,
        })
      );
    } else {
      request.push([]);
    }
    try {
      const result = await Promise.all(request);
      const itemsNeedRemove = [];
      this.getItems.map((item, index) => {
        if (item.set_item_code && result[0]) {
          let itemSale = (result[0] as SaleBoom[]).find(
            (itemSale) => itemSale.set_item_code === item.set_item_code
          );
          if (itemSale) {
            itemSale.cart_quanlity = item.cart_quanlity;
            itemSale.mnfct_num = item.mnfct_num || null;
            itemSale.order_num = item.order_num || null;
            itemSale.cart_orre_ctrl_num = item.cart_orre_ctrl_num || null;
            this.items.push(new SaleBoom({ ...itemSale }));
          } else {
            itemsNeedRemove.push(index);
          }
        } else if (item.set_item_code == null && result[1]) {
          const products: Product[] = result[1]["list"];
          let itemProduct = products.find(
            (itemSale) => itemSale.item_code === item.item_code
          );
          if (itemProduct) {
            itemProduct.cart_quanlity = item.cart_quanlity;
            itemProduct.mnfct_num = item.mnfct_num || null;
            itemProduct.order_num = item.order_num || null;
            itemProduct.cart_orre_ctrl_num = item.cart_orre_ctrl_num || null;
            this.items.push(new Product({ ...itemProduct }));
          } else {
            itemsNeedRemove.push(index);
          }
        }
      });
      if (itemsNeedRemove.length > 0) {
        itemsNeedRemove.map((itemKey) => {
          this.cartRemove(itemKey);
          return itemKey;
        });
      }
    } catch (error) {
      console.error(error);
      qNotify.error({
        text: this.$t("error"),
      });
    } finally {
      // loader.hide();
    }
  }

  get shippingFee() {
    // this.shippingFeePrice;
    console.log(
      "shipping free",
      this.items.total,
      this.deliveryConfig.free_shipping,
      this.shippingFeePrice
    );
    if (this.items.total > this.deliveryConfig.free_shipping) {
      return 0;
    }
    // get fee shipping from postal code
    return this.shippingFeePrice;
  }

  get shippingPipeFee() {
    if (!this.items.hasPipeItem) {
      return 0;
    }
    // get fee shipping from postal code
    return this.shippingPipeFeePrice * this.items.pipeItems().length;
  }

  get expiredTime() {
    if (this.form.desire_dlvr_day) {
      return `${this.form.desire_dlvr_day} ${
        this.deliveryConfig.order_deadline_hour
      }:${
        this.deliveryConfig.order_deadline_minute
          ? this.deliveryConfig.order_deadline_minute
          : "00"
      }`;
    } else {
      return "";
    }
  }

  get subTotal() {
    this.shippingFeePrice;
    this.shippingPipeFeePrice;
    console.log(this.shippingFee, this.shippingPipeFee, this.items.total);
    return this.shippingFee + this.shippingPipeFee + this.items.total;
  }

  get total() {
    return this.subTotal + this.tax;
  }

  get tax() {
    let tax = this.subTotal * (this.consumptionTax / 100);
    switch (Number.parseInt(this.customer.tax_numbering_kbn)) {
    case 0:
      tax = Math.floor(tax);
      break;
    case 1:
      tax = Math.ceil(tax);
      break;
    case 2:
      tax = Math.round(tax);
      break;
    }

    return tax;
  }

  get isOverExceed() {
    return moment(this.form.desire_dlvr_day).isBefore(
      this.deliveryConfigMaxTimeExceeded
    );
  }

  showAttention(item: any) {
    const totalOrder = this.items.list
      .filter((cart) => cart.item.item_code === item.item_code)
      /* eslint-disable unicorn/no-array-reduce */
      .reduce((memo, cart) => {
        let totalQuantity = 0;
        if (cart.item.set_item_code) {
          totalQuantity =
            (cart.item.cart_quanlity - 0) * cart.item.quantity_per_carton;
        } else {
          totalQuantity = cart.item.cart_quanlity - 0;
        }
        return totalQuantity + (memo - 0);
      }, 0);

    console.log("totalOrder", totalOrder);
    if (item.set_item_code) {
      // HORIKOSHI品目マスタ”max_orre_quantity” < 　　purchase quantity × quantity_per_carton
      const saleBoom = item as SaleBoom;
      if (!saleBoom.product.master_product.max_orre_quantity) {
        return false;
      }

      return (
        saleBoom.product.master_product.max_orre_quantity < totalOrder &&
        this.isOverExceed
      );
    } else {
      const product = item as Product;
      if (!product.master_product.max_orre_quantity) {
        return false;
      }
      // 受注数上限値 < 購入数量 / purchase quantity < max_orre_quantity
      return (
        product.master_product.max_orre_quantity < totalOrder &&
        this.isOverExceed
      );
    }
  }

  async shippingFeeByPref() {
    if (!this.deliveryInfo.prefectures_code) {
      this.shippingFeePrice = 0;
      this.shippingPipeFeePrice = 0;
      return;
    }
    const result = await commonApi.shippingFeeByPref({
      id: this.deliveryInfo.prefectures_code,
      notLoading: true,
    });

    // Call API sawaga postal code
    const sagawa = await commonApi.sagawaPostal({
      code: this.deliveryInfo.postal_code,
    });
    this.relayFree = _get(sagawa, "relay_charge_kbn", 0);

    if (result) {
      this.shippingFeePrice = result.delivery_price_cart - 0;
      this.shippingPipeFeePrice = result.straight_dlv_price_cart - 0;
    }
  }

  selectDestination() {
    (this.$refs.deliveryListPopup as DeliveryDestinationList).showMe();
  }

  onSelectDelivery(destination) {
    this.deliveryDestination = destination;
    this.form.usingInfoAsDelivery = false;

    if (!this.form.usingInfoAsDelivery) {
      console.log("Delivery destination", this.deliveryDestination);
      this.form.delivery.dlv_dst_supervisor_name =
        this.deliveryDestination.supervisor_name;
      this.form.delivery.ship_lbl_note = this.deliveryDestination.dlv_fmt_note;

      this.deliveryInfo.dst_name = this.deliveryDestination.dlv_dst_name;
      this.deliveryInfo.postal_code = this.deliveryDestination.postal_code;
      this.deliveryInfo.address_1 = this.deliveryDestination.address_1;
      this.deliveryInfo.address_2 = this.deliveryDestination.address_2;
      this.deliveryInfo.tel_number = this.deliveryDestination.tel_number;
      this.deliveryInfo.prefectures_code =
        this.deliveryDestination.prefectures_code;
      this.deliveryInfo.cart_dlv_dst_code =
        this.deliveryDestination.cart_dlv_dst_code;
      this.deliveryInfo.prefecture_name =
        this.deliveryDestination.prefectures_name;
    }

    this.shippingFeeByPref();
    (this.$refs.deliveryListPopup as DeliveryDestinationList).hideMe();
    // hide error
    this.clearError("dlv_dst_supervisor_name");
    this.clearError("ship_lbl_note");
  }

  checkOrder() {
    if (!this.deliveryInfo.dst_name) {
      qNotify.error({
        text: "納入先情報を入力してください",
      });
    }
    return true;
  }
  goBackEdit() {
    this.edit = true;
    VueScrollTo.scrollTo({ force: true });
  }

  async confirmOrder() {
    if (!this.orderId && !this.checkItemAvaiable()) {
      return;
    }

    this.errors = {};
    if (!this.canProcess()) {
      return;
    }

    if (this.checkOrder() && (await this.submit(true)) === HTTP_STATUS_OK) {
      VueScrollTo.scrollTo({ force: true });
      this.edit = false;
    }
  }

  public removeCart(index) {
    const product = this.items.list[index];
    this.$modal.showDelete({
      text: this.$t("cart_page.messsage.delete_message", {
        item_name_1: product.itemName,
        item_name_2: product.itemName2,
        item_code: product.itemCode,
      }),
      confirmClass: "mb__add-color-red",
      title: this.$t(
        this.orderId
          ? "cart_page.messsage.title_popup_delete_order"
          : "cart_page.messsage.title_popup_delete"
      ),
      cancelText: this.$t("common.message.cancel_delete_button"),
      // we are passing callback method for our confirm button
      onConfirm: () => {
        this.items.list.splice(index, 1);
        // if load from order then do not remove cart
        !this.orderId && this.cartRemove(index);

        // if load from order then remove child row
        this.orderId && this.cartsOfOrder.splice(index, 1);
      },
      onClose: () => {
        console.log("onClose");
      },
    });
  }

  public async removeOrder() {
    this.$modal.showDelete({
      text: `ご注文をキャンセルいたします。<br>
            この操作は取り消せません。よろしいですか？`,
      confirmText: "注文キャンセル",
      cancelText: "戻る",
      title: "注文キャンセル",
      showQuestion: false,
      // we are passing callback method for our confirm button
      onConfirm: async () => {
        let result = await orderApi.delete(this.orderId);
        if (result.status == HTTP_STATUS_NO_CONTENT) {
          // redirect mypage
          return this.$router.push({ name: "customer.mypage" });
        } else {
          qNotify.error({
            text: result.data.message,
          });
        }
      },
      onClose: () => {
        console.log("onClose");
      },
    });
  }

  async submit(validateOnly = false) {
    const delivery = {
      dlv_dst_name: this.deliveryInfo.dst_name,
      cart_dlv_dst_name: this.deliveryInfo.cart_dlv_dst_code || "",
      dlv_dst_postal_code: this.deliveryInfo.postal_code,
      dlv_dst_prefectures_code: this.deliveryInfo.prefectures_code,
      dlv_dst_prefectures_name: this.deliveryInfo.prefecture_name,
      dlv_dst_address_1: this.deliveryInfo.address_1,
      dlv_dst_address_2: this.deliveryInfo.address_2,
      dlv_dst_tel_number: this.deliveryInfo.tel_number,
      dlv_dst_supervisor_name: this.form.delivery.dlv_dst_supervisor_name,
      ship_lbl_note: this.form.delivery.ship_lbl_note,
      using_orderer_address: this.form.usingInfoAsDelivery,
    };

    const formData: any = {
      customer_supervisor_name: this.form.customer_supervisor_name,
      order_num: this.form.order_num,
      mnfct_num: this.form.mnfct_num,
      deliver_time_am: this.form.deliver_time_am ? 1 : 0,
      orre_date: this.form.desire_dlvr_day,
      denno_orre: this.orderId || null,
      postage_item: this.postageItem,
      pip_postage_item: this.pipPostageItem,
    };
    if (validateOnly) {
      formData.validate_only = validateOnly;
    }

    const order = {
      d_slip_cart_orres: [],
    };

    // Set initial
    this.isShowAttent = false;
    this.items.list.map((cart) => {
      const item = cart.item;

      order.d_slip_cart_orres.push({
        item_code: _get(item, "item_code", ""),
        set_item_code: _get(item, "set_item_code", ""),
        quantity: _get(item, "cart_quanlity", 0),
        order_num: _get(item, "order_num", ""),
        mnfct_num: _get(item, "mnfct_num", ""),
        desire_dlvr_day: this.form.desire_dlvr_day,
        cart_orre_ctrl_num: _get(item, "cart_orre_ctrl_num", ""),
      });

      if (!this.isShowAttent && this.showAttention(item)) {
        this.isShowAttent = true;
      }
    });
    const { data, status } = await orderApi.add({
      ...formData,
      ...delivery,
      ...order,
    });

    if (status == HTTP_STATUS_VALIDATE_FAILURE) {
      this.errors = data.meta.errors;
      qNotify.error({
        text: data.meta.message,
      });
      if (this.errors.orre_date) {
        await this.loadDeliverySetting();
        this.generateDate();
      }
      if (!this.edit) {
        VueScrollTo.scrollTo({ force: true });
        this.edit = true;
      }
      // check exit error of shiip
      // loadDeliverySetting
    } else if (status == HTTP_STATUS_CREATED) {
      this.replaceCart([]);
      this.$router.push({ name: "customer.order_thanks", params: {id: data.data.denno_orre} });
    } else if (status == HTTP_STATUS_OK && !validateOnly) {
      this.isComplete = true;
    }
    return status;
  }

  clearError(key) {
    console.log("change", key);
    if (key in this.errors) {
      this.errors[key] = [];
    }
  }

  goBack() {
    if (this.orderId) {
      this.$router.push({ name: "customer.mypage" });
    } else {
      this.$router.push({ name: "customer.carts" });
    }
  }

  get getPrefectureNameCurrentLogin() {
    return this.customer.m_prefecture
      ? this.customer.m_prefecture.prefecture_name
      : "";
  }

  get noImageUrl() {
    return noimage;
  }

  get defaultImage0082() {
    return defaultImage0082;
  }

  get defaultImage0083() {
    return defaultImage0083;
  }

  public showProducts() {
    (this.$refs.productListPopup as ProductListPopup).show();
  }

  async addItems(items) {
    // push item to list
    items
      .map((cart) => {
        if (cart.set_item_code) {
          this.cartsOfOrder.push({
            set_item_code: cart.set_item_code,
            item_code: cart.item_code,
            cart_quanlity: cart.cart_quanlity ?? 0,
            desire_dlvr_day: '',
            mnfct_num: '',
            order_num: '',
            customer_supervisor_name: this.getCustomerUser.account_supervisor_name,
            // cart_orre_ctrl_num: cart.cart_orre_ctrl_num,
          });
        } else {
          this.cartsOfOrder.push({
            set_item_code: null,
            item_code: cart.item_code,
            cart_quanlity: cart.cart_quanlity ?? 0,
            desire_dlvr_day: '',
            mnfct_num: '',
            order_num: '',
            customer_supervisor_name: this.getCustomerUser.account_supervisor_name,
          });
        }
        this.items.push(cart);
      });

    // move 000082, 000083 to last position
    const postageItemCode = [this.postageItem.item_code, this.pipPostageItem.item_code];
    for (let itemCode of postageItemCode) {
      this.cartsOfOrder.push(
        this.cartsOfOrder.splice(
          this.cartsOfOrder.findIndex(
            (item) => item.item_code == itemCode), 1
        )[0]
      );
    }

    // const postageItem = { ...this.postageItem };
    // const pipPostageItem = { ...this.pipPostageItem };
    // this.items = new CartItemList();
    //
    // await this.loadData();
    // if (this.shippingFee > 0) {
    //   this.postageItem = { ...postageItem };
    // }
    //
    // if (this.shippingPipeFee > 0) {
    //   this.pipPostageItem = { ...pipPostageItem };
    // }
  }

  public async loadPostageItem() {
    const result = await productApi.getMasterProducts({
      item_codes : [ this.postageItem.item_code, this.pipPostageItem.item_code]
    });
    const postageMasterProduct = result.data.find((item) => item.item_code == this.postageItem.item_code);
    const pipPostageMasterProduct = result.data.find((item) => item.item_code == this.pipPostageItem.item_code);
    this.postageItem.item_name = postageMasterProduct.item_name_1;
    this.postageItem.unit = postageMasterProduct.unit;
    this.pipPostageItem.item_name = pipPostageMasterProduct.item_name_1;
    this.pipPostageItem.unit = pipPostageMasterProduct.unit;
  }
}
